export default class Org {
  constructor () {
    this.id = 0
    this.name = ''
    this.type = ''
    this.website = ''
  }
}
